import { render, staticRenderFns } from "./UniversesView.vue?vue&type=template&id=3649456e&scoped=true"
import script from "./UniversesView.vue?vue&type=script&lang=js"
export * from "./UniversesView.vue?vue&type=script&lang=js"
import style0 from "./UniversesView.vue?vue&type=style&index=0&id=3649456e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3649456e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3649456e')) {
      api.createRecord('3649456e', component.options)
    } else {
      api.reload('3649456e', component.options)
    }
    module.hot.accept("./UniversesView.vue?vue&type=template&id=3649456e&scoped=true", function () {
      api.rerender('3649456e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UniversesView.vue"
export default component.exports